import { useState } from "react";
import OptionsPanel from "../components/layout/OptionsPanel";
import ThemePicker from "../components/layout/ThemePicker";
import Timing from "../components/matches/Timing";
import { useLanguage } from "../context/Language/LanguageContext";

function Settings({ onSettingsChange }) {
  const { t } = useLanguage();
  const [activeTab, setActiveTab] = useState("theme");

  const doThemeChange = (th) => {
    onSettingsChange({ theme: th });
    // document.getElementById("my-modal-themes").checked = false;
  };

  return (
    <>
      <div className="p-2">
        <div role="tablist" className="tabs tabs-boxed inline-flex mb-2">
          <button
            type="button"
            role="tab"
            className={"tab" + (activeTab === "theme" ? " tab-active" : "")}
            onClick={() => setActiveTab("theme")}
          >
            {t("Theme")}
          </button>
          <button
            type="button"
            role="tab"
            className={"tab" + (activeTab === "options" ? " tab-active" : "")}
            onClick={() => setActiveTab("options")}
          >
            {t("Options")}
          </button>
          <button
            type="button"
            role="tab"
            className={"tab" + (activeTab === "timing" ? " tab-active" : "")}
            onClick={() => setActiveTab("timing")}
          >
            {t("Video timing")}
          </button>
        </div>

        {activeTab === "theme" ? (
          <ThemePicker onThemeChange={(th) => doThemeChange(th)} />
        ) : activeTab === "options" ? (
          <OptionsPanel />
        ) : (
          <div className="flex flex-col gap-1 p-4 max-w-2xl">
            <h2 className="text-lg font-bold mb-1">{t("Video timing")}</h2>
            <p className="text-sm text-base-content/70 mb-3">
              {t("Default lead time (seconds before an event to start playback) and clip duration, per skill.")}
            </p>
            <Timing onClose={() => {}} />
          </div>
        )}
      </div>
    </>
  );
}

export default Settings;
